import { render, staticRenderFns } from "./bigCustomerProp.vue?vue&type=template&id=37607220&scoped=true&"
import script from "./bigCustomerProp.vue?vue&type=script&lang=js&"
export * from "./bigCustomerProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37607220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37607220')) {
      api.createRecord('37607220', component.options)
    } else {
      api.reload('37607220', component.options)
    }
    module.hot.accept("./bigCustomerProp.vue?vue&type=template&id=37607220&scoped=true&", function () {
      api.rerender('37607220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/bigCustomer/followRecord/detail/bigCustomerProp.vue"
export default component.exports